import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from 'src/app/core/services/user.service';
import { TextSearchService } from 'src/app/services/text-search.service';

@Component({
  selector: 'app-full-text-search',
  templateUrl: './full-text-search.component.html',
  styleUrls: ['./full-text-search.component.scss'],
})
export class FullTextSearchComponent implements OnInit {
  optionTextSearch = ['Todos', 'Casos', 'Tareas'];
  optionSelect = 'Todos';
  filters = [];
  form: FormGroup = this.fb.group({
    filters: [],
  });
  content = { casos: [], tareas: [] };
  text: string;
  constructor(
    private textSearchService: TextSearchService,
    public fb: FormBuilder,
    private userService: UserService
  ) {}

  ngOnInit() {}

  async search() {
    let options = {
      option: this.optionSelect,
      filters: {
        tipo_caso: this.form.value.filters ? this.form.value.filters : [],
      },
    };
    let units = this.userService.currentUser?.role.units;
    this.textSearchService
      .search(
        this.text == undefined ? '' : this.text,
        options,
        units,
        undefined,
        undefined
      )
      .subscribe((response) => {
        this.content.casos = response.casoSearch;
        this.content.tareas = response.tareacaso;
      });
  }
}
